import { lazy } from 'react';

const soList = lazy(() => import('../../../screen/AntrepoStok/SOList/SOList'));

const GitReport = lazy(() =>
  import('../../../screen/AntrepoStok/GitReport/GitReport')
);

const GitMoves = lazy(() =>
  import('../../../screen/AntrepoStok/GitReportMoves/GitReportMoves')
);

const GitInvoices = lazy(() =>
  import('../../../screen/AntrepoStok/GitInvoicesList/GitInvoicesList')
);

const GitMovesDetail = lazy(() =>
  import(
    '../../../screen/AntrepoStok/GitReportMovesDetail/GitReportMovesDetail'
  )
);

const GitInvoicesDetail = lazy(() =>
  import('../../../screen/AntrepoStok/GitInvoicesSettings/GitInvoicesSettings')
);

const ProductDeclaration = lazy(() =>
  import('../../../screen/AntrepoStok/ProductDeclaration/ProductDeclaration')
);

const ProductDeclarationDetail = lazy(() =>
  import(
    '../../../screen/AntrepoStok/ProductDeclarationDetail/ProductDeclarationDetail'
  )
);

const ShipmentDeclarationList = lazy(() =>
  import(
    '../../../screen/AntrepoStok/ShipmentDeclarationList/ShipmentDeclarationList'
  )
);

const BeyannameSorgula = lazy(() =>
  import('../../../screen/AntrepoStok/BeyannameSorgula/BeyannameSorgula')
);

const ShipmentDeclarationDetail = lazy(() =>
  import('../../../screen/AntrepoStok/ShipmentDeclaration/ShipmentDeclaration')
);

const ProductList = lazy(() =>
  import('../../../screen/AntrepoStok/ProductList/ProductList')
);

const PaymentDeclaration = lazy(() =>
  import('../../../screen/AntrepoStok/PaymentDeclaration/PaymentDeclaration')
);

const ProductDetail = lazy(() =>
  import('../../../screen/AntrepoStok/ProductDetail/ProductDetail')
);

const AddProduct = lazy(() =>
  import('../../../screen/AntrepoStok/AddProduct/AddProduct')
);

const ConsignmentNote = lazy(() =>
  import('../../../screen/AntrepoStok/ConsignmentNote/ConsignmentNote')
);

const AntrepoBeyannameler = lazy(() =>
  import('../../../screen/AntrepoStok/AntrepoBeyannameler/AntrepoBeyannameler')
);

const AntrepoStokRaporu = lazy(() =>
  import('../../../screen/AntrepoStok/AntrepoStokRaporu/AntrepoStokRaporu')
);

const IthalatBeyannameleri = lazy(() =>
  import(
    '../../../screen/AntrepoStok/IthalatBeyannameleri/IthalatBeyannameleri'
  )
);

const AntrepoStokTalep = lazy(() =>
  import('../../../screen/AntrepoStok/AntrepoStokTalep/AntrepoStokTalep')
);

const AntrepoStokTalepListesi = lazy(() =>
  import(
    '../../../screen/AntrepoStok/AntrepoStokTalepListesi/AntrepoStokTalepListesi'
  )
);

const AntrepoStokTalepYukle = lazy(() =>
  import(
    '../../../screen/AntrepoStok/AntrepoStokTalepYukle/AntrepoStokTalepYukle'
  )
);

const BeyannameDetaySorgula = lazy(() =>
  import(
    '../../../screen/AntrepoStok/BeyannameDetaySorgula/BeyannameDetaySorgula'
  )
);

const GenelRaporlar = lazy(() =>
  import('../../../screen/AntrepoStok/GenelRaporlar/GenelRaporlar')
);

const GenelRaporlarDetaylar = lazy(() =>
  import('../../../screen/AntrepoStok/GenelRaporlarDetay/GenelRaporlarDetay')
);

const GenelRaporlarDetaylarV2 = lazy(() =>
  import(
    '../../../screen/AntrepoStok/GenelRaporlarDetayV2/GenelRaporlarDetayV2'
  )
);

const GtipTanimlari = lazy(() =>
  import('../../../screen/AntrepoStok/GtipScreen/GtipScreen')
);

const GtipDetaylari = lazy(() =>
  import('../../../screen/AntrepoStok/GtipDetaylari/GtipDetaylari')
);

const SoBeyannameOnizleme = lazy(() =>
  import('../../../screen/AntrepoStok/BeyanDetayOnizleme/TalepBeyanOnizleme')
);

const EskiSolar = lazy(() =>
  import('../../../screen/AntrepoStok/OldSoList/OldSoList')
);

const PlannedJobList = lazy(() =>
  import('../../../screen/DemoSunChemical/PlannedJobList/PlannedJobList')
);

const AddPlanedJob = lazy(() =>
  import('../../../screen/DemoSunChemical/NewPlannedJob/NewPlannedJob')
);

const ContainerTracking = lazy(() =>
  import('../../../screen/DemoSunChemical/ContainerTracking/ContainerTracking')
);

const DemoExcel = lazy(() =>
  import('../../../screen/DemoSunChemical/DemoExcel/DemoExcel')
);

const DocumentTracking = lazy(() =>
  import('../../../screen/AntrepoStok/DocumentTracking/DocumentTracking')
);

const DocumentTrackingNew = lazy(() =>
  import('../../../screen/AntrepoStok/DocumentTrackingNew/DocumentTrackingNew')
);

const DocumentTrackingDetail = lazy(() =>
  import(
    '../../../screen/AntrepoStok/DocumentTrackingDetail/DocumentTrackingDetail'
  )
);

const Order = lazy(() => import('../../../screen/AntrepoStok/Order/Order'));

const OrderList = lazy(() =>
  import('../../../screen/AntrepoStok/OrderList/OrderList')
);

const OrderListV2 = lazy(() =>
  import('../../../screen/AntrepoStok/OrderListV2/OrderListV2')
);

const GeciciIthalat = lazy(() =>
  import('../../../screen/AntrepoStok/GeciciIthalat/GeciciIthalat')
);

const IhbarTespit = lazy(() =>
  import('../../../screen/AntrepoStok/IhbarTespit/IhbarTespit')
);

const OrderMasraf = lazy(() =>
  import('../../../screen/AntrepoStok/OrderMasraf/OrderMasraf')
);

const ProductTariffList = lazy(() =>
  import('../../../screen/AntrepoStok/ProductTariffList/ProductTariffList')
);

const ProductTariffUpdateScreen = lazy(() =>
  import(
    '../../../screen/AntrepoStok/ProductTariffUpdateScreen/ProductTariffUpdateScreen'
  )
);

const IthalatBeyannamesi = lazy(() =>
  import('../../../screen/AntrepoStok/Beyanname/IthalatBeyannamesi.js')
);

const IthalatListe = lazy(() =>
  import('../../../screen/AntrepoStok/Beyanname/IthalatListe.js')
);

const OrderMasrafDekont = lazy(() =>
  import('../../../screen/AntrepoStok/OrderMasrafDekont/OrderMasrafDekont')
);

const OrderMasrafDetay = lazy(() =>
  import('../../../screen/AntrepoStok/OrderMasrafDetay/OrderMasrafDetay')
);

const TareksList = lazy(() =>
  import('../../../screen/AntrepoStok/TareksList/TareksList')
);

const TareksDetail = lazy(() =>
  import('../../../screen/AntrepoStok/TareksDetail/TareksDetail')
);

const ProductCategories = lazy(() =>
  import('../../../screen/AntrepoStok/ProductCategories/ProductCategories')
);

const CezaTakip = lazy(() =>
  import('../../../screen/AntrepoStok/CezaTakip/CezaTakip')
);

const TransferBildirim = lazy(() =>
  import('../../../screen/AntrepoStok/TransferBildirim/TransferBildirim')
);

const Ncts = lazy(() => import('../../../screen/AntrepoStok/Ncts/Ncts'));

const NctsList = lazy(() =>
  import('../../../screen/AntrepoStok/NctsList/NctsList')
);

const Muhasebe = lazy(() =>
  import('../../../screen/AntrepoStok/Muhasebe/Muhasebe')
);
const WorkOrder = lazy(() =>
  import('../../../screen/AntrepoStok/WorkOrder/WorkOrder')
);
const WorkOrderList = lazy(() =>
  import('../../../screen/AntrepoStok/WorkOrderList/WorkOrderList')
);
const CompanyProduct = lazy(() =>
  import('../../../screen/AntrepoStok/CompanyProduct/CompanyProduct')
);

const E2eList = lazy(() =>
  import('../../../screen/AntrepoStok/E2eList/E2eList')
);

const PumaWeekReport = lazy(() =>
  import('../../../screen/AntrepoStok/PumaWeekReport/PumaWeekReport')
);

const ProcessedDocumentEdit = lazy(() =>
  import('../../../screen/AI/ProcessedDocumentEdit')
);

const ExportList = lazy(() =>
  import('../../../screen/AntrepoStok/ExportList/ExportList')
);

const LadingDocument = lazy(() =>
  import('../../../screen/AntrepoStok/LadingDocument/LadingDocument')
);

const DeliveryOrderDocument = lazy(() =>
  import(
    '../../../screen/AntrepoStok/DeliveryOrderDocument/DeliveryOrderDocument'
  )
);

const ProjectList = lazy(() =>
  import('../../../screen/AntrepoStok/ProjectList/ProjectList')
);

const IcPiyasaList = lazy(() =>
  import('../../../screen/AntrepoStok/IcPiyasaList/IcPiyasaList')
);
const TuborgOTVTakibi = lazy(() =>
  import('../../../screen/AntrepoStok/Tuborg/OTVTeminatTakibi')
);

const PreRegistrationCheck = lazy(() =>
  import('../../../screen/AntrepoStok/TescilOncesiKontrol/PreRegistrationCheck')
);

const OrderReExport = lazy(() =>
  import('../../../screen/AntrepoStok/OrderReExport/OrderReExport')
);

const OrderReExportStore = lazy(() =>
  import('../../../screen/AntrepoStok/OrderReExportStore/OrderReExportStore')
);

const OrderReExportInvoiceDraft = lazy(() =>
  import(
    '../../../screen/AntrepoStok/OrderReExportInvoiceDraft/OrderReExportInvoiceDraft'
  )
);

export {
  soList,
  GitReport,
  GitMoves,
  GitInvoices,
  GitMovesDetail,
  GitInvoicesDetail,
  ProductDeclaration,
  ShipmentDeclarationDetail,
  ProductDeclarationDetail,
  ShipmentDeclarationList,
  ProductList,
  ProductDetail,
  ConsignmentNote,
  AntrepoBeyannameler,
  AntrepoStokRaporu,
  IthalatBeyannameleri,
  AntrepoStokTalep,
  AntrepoStokTalepListesi,
  AntrepoStokTalepYukle,
  PaymentDeclaration,
  BeyannameDetaySorgula,
  BeyannameSorgula,
  GenelRaporlar,
  GenelRaporlarDetaylar,
  GenelRaporlarDetaylarV2,
  GtipTanimlari,
  GtipDetaylari,
  SoBeyannameOnizleme,
  EskiSolar,
  PlannedJobList,
  AddPlanedJob,
  ContainerTracking,
  DemoExcel,
  AddProduct,
  DocumentTracking,
  DocumentTrackingNew,
  DocumentTrackingDetail,
  Order,
  OrderList,
  OrderListV2,
  GeciciIthalat,
  IhbarTespit,
  OrderMasraf,
  ProductTariffList,
  ProductTariffUpdateScreen,
  IthalatBeyannamesi,
  IthalatListe,
  OrderMasrafDekont,
  OrderMasrafDetay,
  TareksList,
  TareksDetail,
  ProductCategories,
  CezaTakip,
  TransferBildirim,
  Ncts,
  NctsList,
  Muhasebe,
  WorkOrder,
  WorkOrderList,
  CompanyProduct,
  ProcessedDocumentEdit,
  E2eList,
  PumaWeekReport,
  ExportList,
  LadingDocument,
  DeliveryOrderDocument,
  ProjectList,
  IcPiyasaList,
  PreRegistrationCheck,
  TuborgOTVTakibi,
  OrderReExport,
  OrderReExportStore,
  OrderReExportInvoiceDraft,
};
